import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { submitAnswersRequest } from "../services/apiService";

const initialState = {
  isLoader: false,
  isError: false,
  message: ""
};

export const setAnswers = createAsyncThunk(
  "send/feedbackQuesion",
  async (payload: any, { rejectWithValue }) => {
    try {
      const answerPayload = JSON.parse(payload);
      // console.log('answerPayload :>>', answerPayload);
      if (answerPayload?.id && answerPayload?.answersList && Array.isArray(answerPayload?.answersList) && answerPayload?.answersList.length) {
        const response: any = await submitAnswersRequest(answerPayload); 
        return response;
      }
    } catch (error: any) {
      // console.log("answer post err :>>", error);
      throw rejectWithValue(error.message);
    }
  }
);
// Then, handle actions in your reducers:
const submitAnswerSlice = createSlice({
  name: 'submitAnswer',
  initialState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
  },
  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder
      .addCase(setAnswers.pending, (state, action) => {
        state.isLoader = true
      })
      .addCase(setAnswers.fulfilled, (state: any, action: any) => {
        const { payload } = action;
        state.isLoader = false
        state.isError = false
        state.message = payload.message
      })
      .addCase(setAnswers.rejected, (state: any, action: any) => {
        state.isError = true
        state.message = action.payload
        state.isLoader = false
      })
  },
});

const { reducer } = submitAnswerSlice;
export default reducer;